document.addEventListener("DOMContentLoaded", function () {
	psInitReactStatsCounter();
});
function psInitReactStatsCounter() {

  const statsSections = document.querySelectorAll(".ps_wp_stats");

  // run only if component exists
  if (!statsSections.length) return;

  const animateCounter = (counter) => {
    const target = parseFloat(counter.dataset.target);
    const prefix = counter.dataset.prefix || "";
    const suffix = counter.dataset.suffix || "";
    const duration = 1500;
    const startTime = performance.now();

    const update = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const value = target * progress;

      if (target % 1 !== 0) {
        counter.innerText = prefix + value.toFixed(1) + suffix;
      } else {
        counter.innerText = prefix + Math.floor(value) + suffix;
      }

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    };

    requestAnimationFrame(update);
  };


  const observer = new IntersectionObserver((entries, obs) => {

    entries.forEach(entry => {

      if (entry.isIntersecting) {

        const counters = entry.target.querySelectorAll(".ps_counter");

        counters.forEach(counter => {
          if (!counter.classList.contains("ps_started")) {
            counter.classList.add("ps_started");
            animateCounter(counter);
          }
        });

        obs.unobserve(entry.target);

      }

    });

  }, { threshold: 0.4 });


  statsSections.forEach(section => observer.observe(section));

}